import { PROYECT } from "services/api";
import { reportSalesCustomerTypes } from "redux/reducers/Reports/reportSalesCustomer/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_SALES_CUSTOMER_FILTERS } = reportSalesCustomerTypes


export const getReportSalesCustomerAction = ({startDate, endDate, stations, customer, isPdf = true}) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    let stationUrl = "";
    let fileNameStation = "";
    stations.map(station => {
      stationUrl = `${stationUrl}&stations=${station.id}`;
      fileNameStation = `${fileNameStation}_${station.name}`;
    });
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/sales-by-customer?start=${startDate}&end=${endDate}${stationUrl}&idCustomer=${customer.idCustomer}&pdf=${isPdf}`;
    const fileName = `Reporte_Venta_por_Cliente_${customer.alias}_${startDate}_${endDate}_${fileNameStation}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingReportSalesCustomer'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? 'PDF' : 'Excel'} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportSalesCustomer'))
    }
  }
}

export const setReportSalesCustomerFilters = (key = "", value) => {
  return {
    type: SET_REPORT_SALES_CUSTOMER_FILTERS,
    payload: { value, key }
  }
}
